export const getlocationDataMapper = (data) => {
    const result = {
        locate: []
    };
    if (data && data.length > 0) {
        result.locate = data;
    }
    return result;
};
